import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { CircularProgress, Divider } from 'base-ui'

import { useOpenableControls } from '../../../generic-hooks'
import { useGlobalConfigContext } from '../../../global-config'
import { LoginRegistrationUserLoginModal } from '../../../login-registration'
import {
  refetchUseApiOrdersSwrGetLastOrder,
  useApiOrdersSwrGetLastOrder,
} from '../../../order'
import { contactPageAccessorGetOrderSectionData } from '../../contactPageAccessorGetOrderSectionData'
import { useScrollToIdIntoViewWhenHashInUrlAfterLoading } from '../../hooks/useScrollToIdIntoViewWhenHashInUrlAfterLoading'

import { ContactPageOrdersSectionContent } from './ContactPageOrdersSectionContent'

export const ContactPageOrdersSection: FC = () => {
  const { data: lastOrder, error, isLoading } = useApiOrdersSwrGetLastOrder()
  const globalConfig = useGlobalConfigContext()
  const intl = useIntl()
  const userModalControls = useOpenableControls()

  useScrollToIdIntoViewWhenHashInUrlAfterLoading(
    '#direct-contact',
    '#direct-contact-section',
    isLoading,
  )

  const orderSectionData = contactPageAccessorGetOrderSectionData(
    {
      globalConfig,
      intl,
      isUserLoggedIn: !error,
    },
    lastOrder?.totalOrderItems,
  )

  return (
    <div className="w-full bg-light-primary-low px-4 py-6 pt-9 tablet:py-12 tablet:text-start">
      <div className="tablet:container">
        <div className="tablet:flex">
          <div className="flex flex-col">
            <h1 className="mb-2 text-2xl font-medium">
              <FormattedMessage id="helpCenter.title" />
            </h1>
            <p className="text-l text-dark-primary-strong tablet:mb-9">
              {orderSectionData.description}
            </p>
          </div>
        </div>

        <div className="flex w-full justify-center">
          {isLoading ? (
            <CircularProgress className="shrink-0 py-16 text-3xl text-dark-brand" />
          ) : (
            <ContactPageOrdersSectionContent
              handleLoginModalOpen={() => {
                userModalControls.handleOpen()
              }}
              isUserLoggedIn={!error}
            />
          )}
        </div>

        <Divider className="mt-6 tablet:mt-12" />

        <LoginRegistrationUserLoginModal
          afterLoggedIn={() => {
            void refetchUseApiOrdersSwrGetLastOrder()
            userModalControls.handleClose()
          }}
          onClose={userModalControls.handleClose}
          open={userModalControls.isOpen}
        />
      </div>
    </div>
  )
}
